import React, { Component } from 'react'
import 'materialize-css/dist/css/materialize.min.css';
// import M from "materialize-css";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal);

class GiftList extends Component {


    async deleteMessage() {
        MySwal.fire({
            title: "¿Deseas eliminar este regalo?",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, eliminar',
            cancelButtonText: 'No'
        }).then((result) => {
            if (result.value) {
                this.delete();
            }
        });
    }

    async delete() {
        try {
            const response = await fetch(localStorage.getItem("api") + '/gift/' + this.props.gift.id_gift, {
                method: 'DELETE',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    Accept: 'application/json'
                })
            })
            const data = await response.json();

            this.props.refresh();
            MySwal.fire({
                title: data.status,
                timer: 3000
            })
        } catch (err) {
            console.log(err)
            return;
        }
    }

    updateGift = () => {
        var gift = this.props.gift;
        gift.isNew = false;
        gift.btnSubmit = "Actualizar Regalo";

        this.props.update(gift);
    }

    updateCheckBox() {
        return;
    }

    render() {

        return (
            <tr>
                <td>{this.props.gift.name}</td>
                <td>{this.props.gift.description}</td>
                <td>{this.props.gift.point}</td>
                <td>
                    <p>
                        <label>
                            <input type="checkbox" checked={this.props.gift.id_gift_state !== 2 ? true : false} onChange={this.updateCheckBox} />
                            <span></span>
                        </label>
                    </p>
                </td>
                <td>
                    <div>
                        <button className="btn btn-danger" onClick={this.updateGift}><i className="material-icons">edit</i></button>
                        <button className="btn btn-danger red" onClick={this.deleteMessage.bind(this)}><i className="material-icons">delete</i></button>
                    </div>
                </td>
            </tr>
        )
    }

}

export default GiftList